import { ElMessage } from "element-plus";
import { defineStore } from "pinia";
import { 
    getAlarmTableData, getAlarmDataById, deleteAlarmData, auditAlarm, getAlarmDataOptions,
    getAllResource
} from "@/services";

const useAlarmStore = defineStore("alarm", {
    state: () => ({
        pageTitle: '',
        tableAllData: {},
        alarmOptions: [],
        allResourceOptions: []

    }),
    actions: {
        async getAlarmDataOptions() {
            let result = await getAlarmDataOptions();
            let options = []
            this.alarmOptions = []
            if (result.code === 200) {
                for(let item of result.data) {
                    let option = { 
                        label: item, 
                        value: item 
                    }
                    options.push(option)
                }
                this.alarmOptions = options
            } else {
                ElMessage({
                    type: 'error',
                    message: result.message
                })
            }
        },
        async getAllResource() {
            let result = await getAllResource();
            let options = []
            this.allResourceOptions = []
            if (result.code === 200) {
                for(let item of result.data) {
                    let option = { 
                        label: item, 
                        value: item 
                    }
                    options.push(option)
                }
                this.allResourceOptions = options
            } else {
                ElMessage({
                    type: 'error',
                    message: result.message
                })
            }
        },
        async getAlarmDataById(params) {
            let result = await getAlarmDataById(params);
            return result.data
        },
        async deleteTableData(params) {
            let result = await deleteAlarmData(params)
            return result
        },
        
        async getTableAllData(params) {
            let result = await getAlarmTableData(params)
            this.tableAllData = result.data
        },
        async auditAlarm(params) {
            let result = await auditAlarm(params);
            return result
        },
        
    },
});

export default useAlarmStore;
